import _ from 'lodash'
import cx from 'classnames'
import { ERROR } from '../../../../../../constants/globalTypes'
import { FORM_ERROR_CLASS_NAME } from '../../../../../../styles/variables'
import PrefixBlock from '../../../PrefixBlock'

const StatusSuccessPrefixBlock = props => {
  const {
    listingId,
    failedProposal
  } = props

  return (
    <PrefixBlock
      type={ERROR}
      className={cx(
        // 會用於判斷頁面上是否有錯誤欄位 scroll 到目標的 selector
        FORM_ERROR_CLASS_NAME,
        'failed'
      )}
    >
      <span id={listingId}>
        修改失敗：
        {
          _.get(failedProposal, 'error.debugError.detail[0].message') ||
          _.get(failedProposal, 'message')
        }
      </span>
    </PrefixBlock>
  )
}

export default StatusSuccessPrefixBlock
